<app-admin-file-upload
  [allTermData]="allTermData$ | async"
  (outputOnUpload)="onUpload($event)"
  [fileUploadStatus]="fileUploadStatus"
  [preSelectedTermId]="preSelectedTermId"
  [isOpen]="isOpen"
></app-admin-file-upload>
